module.exports = __webpack_public_path__ + "img/logo.e07d80ac.png";